import { writable } from "svelte/store";

export const sharedAccountUserLabels = writable<Record<string, string>>({});

export const resetSharedAccountUserLabels = (): void => {
  sharedAccountUserLabels.set({});
};

